export default __webpack_public_path__ + "static/media/landscaping3.5e5f830f.jpg";